(function () {
    'use strict';

    angular
        .module('adminReferenceDataRoutes', [
            'adminReferenceDataControllers'
        ])
        .config(router);

    router.$inject = ['$stateProvider'];

    function router($stateProvider) {
        $stateProvider
                .state('admin.referenceData', {
                    url: '/ReferenceData',
                    resolve: {
                        itemTypes: function () {
                            return [{ ItemTypeID: 70, TitleEN: "SectionBlock" }];
                        },
                    },
                    views: {
                        'mainContent@admin': {
                            templateUrl: require('./AdminReferenceData.tpl.html'),
                            controller: 'AdminReferenceDataController'
                        }
                    }
                });
    }
})();